import React from "react";
import "./additionalStyles.css";
import githubLogo from "../../images/githubLogo.png";
import linkedInLogo from "../../images/linkedinLogo.png";
import websiteLogo from "../../images/website-Logo.png";

const styles = {
  tag: {
    flex: "0 0 30%",
    maxWidth: "100%",
    minWidth: "300px",
    display: "grid",
    gridTemplateAreas: "'image title' 'image description' 'social social'",
    margin: "10px",
    padding: "10px",
    borderRadius: "4px",
    boxShadow: "2px 2px 8px 2px rgba(0, 0, 0, 0.2)",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
  },
  imageContainer: {
    width: "8vw",
    height: "8vw",
    minWidth: "100px",
    minHeight: "100px",
    maxWidth: "150px",
    maxHeight: "150px",
    borderRadius: "50%",
    overflow: "hidden",
    display: "flex",
    alignContent: "center",
    justifyContent: "center",
    gridArea: "image",
    marginRight: "10px",
  },
  image: {
    objectFit: "contain",
  },
  titleWrapper: { display: "flex", flexDirection: "column", gridArea: "title" },
  name: {
    fontWeight: 600,
    fontSize: "16pt",
    margin: "0px",
    gridArea: "name",
    textAlign: "start",
    color: "#494848",
    fontFamily: "'Permanent Marker', cursive",
  },
  description: {
    margin: "0px",
    fontSize: "10pt",
    gridArea: "description",
    textAlign: "start",
  },
  socialMediaButtonRow: {
    gridArea: "social",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: "4px",
    borderTop: "0.5px solid #A9A9A9",
    marginTop: "4px",
  },
  buttonLogo: {
    width: "20px",
    height: "auto",
    marginRight: "6px",
  },
  buttonLinks: {
    textDecoration: "none",
  },
  roleWrapper: {
    gridArea: "role",
    display: "flex",
    alignItems: "center",
    width: "max-content",
    padding: "4px 6px",
    borderRadius: "4px",
    backgroundColor: "#281B4B",
    color: "white",
    marginBottom: "4px",
  },
  roleText: {
    margin: "0px",
    fontWeight: 600,
    fontFamily: "Roboto",
    fontSize: "8pt",
    textAlign: "left",
  },
  roleIcon: { width: "25px", height: "auto", marginRight: "6px" },
};
const TeamMemberTag = ({
  imglink,
  name,
  role,
  icon,
  description,
  linkedInURL,
  githubURL,
  websiteURL,
}) => {
  return (
    <div style={styles.tag}>
      <div style={styles.imageContainer}>
        <img style={styles.image} src={imglink} alt="teamMemberImage" />
      </div>
      <div className="titleWrapper" style={styles.titleWrapper}>
        <h3 style={styles.name}>{name}</h3>
        <div className="roleWrapper" style={styles.roleWrapper}>
          <img style={styles.roleIcon} src={icon} alt="roleIcon" />
          <p style={styles.roleText}>{role}</p>
        </div>{" "}
      </div>
      <p style={styles.description}>{description}</p>
      <div style={styles.socialMediaButtonRow}>
        {linkedInURL && (
          <a
            style={styles.buttonLinks}
            href={linkedInURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="socialMediaButton">
              <img
                style={styles.buttonLogo}
                src={linkedInLogo}
                alt="linkedInLogo"
              />
              Linked In
            </button>
          </a>
        )}
        {websiteURL && (
          <a
            style={styles.buttonLinks}
            href={websiteURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="socialMediaButton">
              <img
                style={styles.buttonLogo}
                src={websiteLogo}
                alt="websiteLogo"
              />
              Website
            </button>
          </a>
        )}
        {githubURL && (
          <a
            style={styles.buttonLinks}
            href={githubURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="socialMediaButton">
              <img
                style={styles.buttonLogo}
                src={githubLogo}
                alt="githubLogo"
              />
              Github
            </button>
          </a>
        )}
      </div>
    </div>
  );
};

export default TeamMemberTag;
